<template lang="pug">
  div.wrap-module-user
    ItemUserProfile(v-if="user && currentAvatar" :user="user" :avatar="currentAvatar")
</template>

<style lang="scss" scoped>
.wrap-module-user {
}
</style>

<script>
import db from '@/components/utils/firebase'
import { createNamespacedHelpers } from 'vuex'
import ItemUserProfile from '@/components/item/ItemUserProfile'
const { mapState: mapStateAuth } = createNamespacedHelpers('auth')

export default {
  components: {
    ItemUserProfile
  },
  computed: {
    ...mapStateAuth([
      'uid'
    ])
  },
  props: {

  },
  data () {
    return {
      user: null,
      currentAvatar: null
    }
  },
  async created () {
    this.user = await db.collection('users')
      .doc(this.$route.params.uid)
      .get()
      .then((d) => {
        var user = d.data()
        user.uid = d.id
        return user
      })

    this.currentAvatar = await db.collection('avatars')
      .doc(this.user.avatar)
      .get()
      .then((d) => {
        var avatar = d.data()
        avatar.id = d.id
        return avatar
      })

    this.$emit('hideNowLoading')
  },
  methods: {
    // ...mapActionsTeam([
    //   'loadMemberUsers'
    // ])
  }
}
</script>
